import { GoalService } from './goal.service';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';

@Injectable()
export class AccessHomePageGuard {
  private goalsUpdated = new Subject<boolean>();
  private hasGoals = false;

  constructor(private goalService: GoalService, private router: Router) {
    console.log('*** AccessHomePageGuard Guard is constructing');
    // Subscribe to all goals updated events to stay responsive to changes
    this.goalService.getGoalsUpdatedEvent().subscribe({
      next: () => {
        this.updateHasGoals();
      }
    });
  }

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    console.log('*** AccessHomePageGuard Guard is canActivate');

    this.goalService.initialiseIfNeeded();  // Initialize goals if needed (ensures auth is ready before HTTP calls)

    if (!this.goalService.isInitialised()) {
      console.log('*** AccessHomePageGuard: canActivate called... returning observable.');
      return this.goalsUpdated;
    }

    this.updateHasGoals();

    return this.hasGoals;
  }

  private navigateOnChangeOfHasGoals() {
    // Only navigate if we're on a route that uses this guard
    // Don't interfere with other routes like /admin
    const currentUrl = this.router.url;
    if (currentUrl.startsWith('/admin') || currentUrl.startsWith('/account') || currentUrl.startsWith('/guilds') || currentUrl.startsWith('/recommendations') || currentUrl.startsWith('/goal') || currentUrl.startsWith('/profile')) {
      return; // Don't navigate away from these routes
    }

    if (this.hasGoals) {
      console.log(`*** AccessHomePageGuard: Navigating to profile/overview`);
      this.router.navigate(['profile/overview'], { replaceUrl: true });
    } else {
      console.log(`*** AccessHomePageGuard: Navigating to goals page`);
      this.router.navigate(['goal'], { replaceUrl: true });
    }
  }

  private updateHasGoals() {
    this.hasGoals = this.goalService.getGoals().length > 0;
    console.log(`*** AccessHomePageGuard: hasActiveGoals update to: ${this.hasGoals}`);
    this.goalsUpdated.next(this.hasGoals);
    this.navigateOnChangeOfHasGoals();
  }
}
